module.exports = __webpack_public_path__ + "static/media/img_0.02ec9602.png";